import './instagram_message.js.coffee'
Namespace 'Models'

class Models.InstagramMessageUnsupported extends Models.InstagramMessage
  constructor: (builder) ->
    super(builder)
    @isKeepconUnsupported = builder.isKeepconUnsupported

  accepts: (visitor) ->
    visitor.visit_instagram_message_unsupported(@)

  getType: ->
    'unsupported'
